module.exports = __webpack_public_path__ + "img/4-5.de11bc13.svg";